"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsConfigurationList_1 = require("./_AnalyticsConfigurationList");
exports.ListBucketAnalyticsConfigurationsOutput = {
    type: "structure",
    required: [],
    members: {
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        ContinuationToken: {
            shape: {
                type: "string"
            }
        },
        NextContinuationToken: {
            shape: {
                type: "string"
            }
        },
        AnalyticsConfigurationList: {
            shape: _AnalyticsConfigurationList_1._AnalyticsConfigurationList,
            locationName: "AnalyticsConfiguration"
        }
    }
};
//# sourceMappingURL=ListBucketAnalyticsConfigurationsOutput.js.map